import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Loader2, Video } from "lucide-react";
import api from "@/lib/api";

// In-site video room: embeds the appointment's Jitsi room in an iframe.
export default function VideoRoom() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading"); // loading | ready | error
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    if (!token) { setState("error"); return; }
    api.get(`/bookings/manage/${token}`)
      .then((res) => {
        const b = res.data.booking || res.data;
        if (b && b.meeting_link) { setBooking(b); setState("ready"); }
        else setState("error");
      })
      .catch(() => setState("error"));
  }, [token]);

  const roomUrl = booking?.meeting_link ? `${booking.meeting_link}#config.prejoinPageEnabled=true` : null;

  return (
    <div data-testid="page-video-room" className="mx-auto max-w-6xl px-4 lg:px-8 py-8">
      <div className="flex items-center gap-2 mb-4 text-charcoal-800">
        <Video className="text-terracotta" strokeWidth={1.5} />
        <h1 className="font-serif text-2xl">Your Hola Movers video call</h1>
      </div>

      {state === "loading" && (
        <div className="py-32 text-center text-charcoal-500"><Loader2 className="mx-auto animate-spin text-sage" size={40} /><p className="mt-4">Loading your room…</p></div>
      )}

      {state === "error" && (
        <div data-testid="video-error" className="py-24 text-center">
          <p className="text-charcoal-700">We couldn't find a confirmed video call for this link.</p>
          <p className="text-charcoal-500 mt-2">Your room appears once your appointment is confirmed. Check your confirmation email or manage your booking.</p>
          <Link to="/book" className="mt-6 inline-flex rounded-full bg-terracotta px-6 py-2.5 text-white font-medium hover:bg-terracotta-hover">Book a call</Link>
        </div>
      )}

      {state === "ready" && (
        <div>
          <div className="rounded-2xl overflow-hidden border border-sand-200 bg-charcoal-900" style={{ height: "70vh" }}>
            <iframe data-testid="video-iframe" title="Video call" src={roomUrl} allow="camera; microphone; fullscreen; display-capture; autoplay" style={{ width: "100%", height: "100%", border: 0 }} />
          </div>
          <p className="mt-3 text-sm text-charcoal-500">Trouble loading? <a href={booking.meeting_link} target="_blank" rel="noreferrer" className="text-terracotta underline">Open the call in a new tab</a>.</p>
        </div>
      )}
    </div>
  );
}
